import { Box } from '@mui/material';

import {
  type QuickFilterDefinition,
  addWhereClause,
  deleteWhereClause,
  scrollablePanelSx,
} from '@modules/_shared/components/filters/Filters';
import { LocalFiltersProvider } from '@modules/_shared/components/filters/LocalFiltersContext';
import { QuickFilter } from '@modules/_shared/components/filters/quick-filters/QuickFilters';
import { SchemaProvider } from '@modules/_shared/components/filters/SchemaProvider';

export interface LocalFiltersProps {
  where: any;
  setWhere: (where: any) => void;
  quickFilters: QuickFilterDefinition[];
  isScraperSchema?: boolean;
}

export const LocalFilters = ({
  where,
  setWhere,
  quickFilters,
  isScraperSchema,
}: LocalFiltersProps) => {
  return (
    <LocalFiltersProvider where={where} setWhere={setWhere}>
      <SchemaProvider isScraperSchema={isScraperSchema}>
        <Box
          sx={{
            ...scrollablePanelSx,
            display: 'flex',
            flexDirection: 'row',
            gap: 1,
            padding: 1,
          }}
        >
          {quickFilters.map(qf => {
            if (qf.shouldDisplay != null && !qf.shouldDisplay(where)) {
              return null;
            }

            return (
              <div key={qf.path.join('.')}>
                <QuickFilter
                  addWhereClause={addWhereClause}
                  deleteWhereClause={deleteWhereClause}
                  isScraperSchema={isScraperSchema}
                  {...qf}
                />
              </div>
            );
          })}
        </Box>
      </SchemaProvider>
    </LocalFiltersProvider>
  );
};
